"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
/** Builds the GraphQL VariableDefinitions for a given {@see VarsConfig} object */
function buildVariables(vars) {
    return Object.entries(vars).map(function (_a) {
        var name = _a[0], type = _a[1];
        return ({
            kind: "VariableDefinition",
            variable: {
                kind: "Variable",
                name: {
                    kind: "Name",
                    value: name,
                },
            },
            type: types_1.buildType(type),
            directives: [],
        });
    });
}
exports.buildVariables = buildVariables;
